import { useCustomMessageFile } from './useCustomMessageFile';

import { MessageFile, MessageFileProps } from '@speeki/chat-web-components';

export const CustomMessageFile = (props: MessageFileProps) => {
    const { currentMessage } = props;

    const { data, loading, openFile } = useCustomMessageFile(
        currentMessage?.file,
    );

    return (
        <MessageFile
            {...props}
            extension={data?.extension}
            loading={loading}
            name={data?.name}
            onClick={openFile}
        />
    );
};
